import { useDispatch, useSelector } from 'react-redux';
import {
    fetchServicesThunk,
    deleteServicesThunk,
    activateServicesThunk,
    saveServiceThunk
} from 'actions/services/ServicesActions';
import { Service, SERVICES_BUSINESS_AREAS } from 'model/Service';
import { generateUniqueCopyName } from 'utils/ServiceUtils';
import { RootState } from 'store';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const useTrainingServices = () => {
    const dispatch = useDispatch();
    const {
        servicesByBusinessArea: { training: trainingState },
        savedService,
        status
    } = useSelector((state: RootState) => state.services);

    const fetchTrainingServices = (
        page = DEFAULT_PAGE,
        pageSize = DEFAULT_PAGE_SIZE,
        status = 'active',
        searchText = '',
        marketplaceIds?: Array<number>
    ) => {
        dispatch(
            fetchServicesThunk(
                undefined,
                page,
                pageSize,
                status,
                undefined,
                searchText,
                SERVICES_BUSINESS_AREAS.TRAINING,
                marketplaceIds?.length ? marketplaceIds : undefined
            )
        );
    };

    const duplicateTrainingService = (service: Service) => {
        const existingNames = trainingState.services.map(s => s.name);
        const uniqueName = generateUniqueCopyName(service.name, existingNames);

        const duplicatedService = {
            ...service,
            id: undefined,
            uuid: '',
            name: uniqueName
        };
        dispatch(saveServiceThunk(duplicatedService, true, true));
    };

    const deleteTrainingService = (serviceId: number) => {
        dispatch(deleteServicesThunk([serviceId]));
    };

    const toggleTrainingServiceStatus = (
        service: Service,
        fetchParams: {
            page: number;
            per: number;
            status: string;
            searchText: string;
            marketplaceIds?: Array<number>;
        }
    ) => {
        const isActive = service.status.id === 1;
        const onSuccess = () => {
            fetchTrainingServices(
                fetchParams.page,
                fetchParams.per,
                fetchParams.status,
                fetchParams.searchText,
                fetchParams.marketplaceIds
            );
        };
        dispatch(activateServicesThunk([service.id!], !isActive, onSuccess));
    };

    return {
        services: trainingState.services,
        meta: trainingState.meta,
        loading: trainingState.loading,
        savedService,
        status,
        fetchTrainingServices,
        duplicateTrainingService,
        deleteTrainingService,
        toggleTrainingServiceStatus
    };
};
